import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function LoginPage() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/portal";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#060D1A] flex items-center justify-center px-4" data-testid="login-page">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-10 text-center"
      >
        <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400 mb-6">
          Client Access
        </p>
        <h1 className="font-display text-3xl font-bold tracking-tight text-white">
          OG Solutions
        </h1>
        <p className="mt-3 text-base text-slate-400">
          Sign in to view your reports, manage your subscription, and track your audit history.
        </p>
        <button
          data-testid="login-google-button"
          onClick={handleGoogleLogin}
          className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-white px-8 py-4 text-base font-semibold text-[#060D1A] transition-colors duration-300 hover:bg-slate-300"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.5h6.5c-.1 1.1-.8 2.7-2.4 3.8l3.7 2.9c2.2-2.1 3.7-5.1 3.7-9z" />
            <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.7-2.9c-1 .7-2.4 1.2-4.2 1.2-3.2 0-5.9-2.1-6.8-5.1l-3.9 3C3.3 21.3 7.3 24 12 24z" />
            <path fill="#FBBC05" d="M5.2 14.3c-.2-.7-.4-1.5-.4-2.3s.1-1.6.4-2.3l-3.9-3C.5 8.3 0 10.1 0 12s.5 3.7 1.3 5.3l3.9-3z" />
            <path fill="#EA4335" d="M12 4.7c1.8 0 3 .8 3.7 1.4l3.3-3.2C17.9 1.1 15.2 0 12 0 7.3 0 3.3 2.7 1.3 6.7l3.9 3c.9-2.9 3.6-5 6.8-5z" />
          </svg>
          Continue with Google
        </button>
        <Link
          to="/"
          data-testid="login-back-home-link"
          className="mt-8 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-white transition-colors duration-300"
        >
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>
      </motion.div>
    </div>
  );
}
